import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { DEFAULT_CONFIG } from "../config/defaults";
import { fetchConfig } from "../lib/api";

const AppContext = createContext(null);

export function AppProvider({ children }) {
  const [config, setConfig] = useState(DEFAULT_CONFIG);
  const [bookingOpen, setBookingOpen] = useState(false);
  const [bookingPrefill, setBookingPrefill] = useState(null);
  const [customer, setCustomer] = useState(() => {
    try {
      const raw = localStorage.getItem("carza_customer");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  });

  useEffect(() => {
    fetchConfig()
      .then((cfg) => cfg && setConfig({ ...DEFAULT_CONFIG, ...cfg }))
      .catch(() => {});
  }, []);

  const signIn = useCallback((token, user) => {
    localStorage.setItem("carza_customer_token", token);
    localStorage.setItem("carza_customer", JSON.stringify(user));
    setCustomer(user);
  }, []);

  const signOut = useCallback(() => {
    localStorage.removeItem("carza_customer_token");
    localStorage.removeItem("carza_customer");
    setCustomer(null);
  }, []);

  const updateCustomer = useCallback((user) => {
    localStorage.setItem("carza_customer", JSON.stringify(user));
    setCustomer(user);
  }, []);

  const openBooking = useCallback((planId) => {
    setBookingPrefill(planId || null);
    setBookingOpen(true);
  }, []);

  const closeBooking = useCallback(() => setBookingOpen(false), []);

  return (
    <AppContext.Provider
      value={{ config, customer, signIn, signOut, updateCustomer, bookingOpen, bookingPrefill, openBooking, closeBooking, setConfig }}
    >
      {children}
    </AppContext.Provider>
  );
}

export const useApp = () => useContext(AppContext);

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -76, duration: 1.2 });
  } else {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}
